import WordPressController from "../controller/WordPressController";

/*
Static Class WPUser (User WordPress)
export: GlobalWPUser;
*/

class WPUser{


    constructor(){

        /*
        Properties
        */
       this.token = null;
       this.user_display_name = null;
       this.user_nicename = null;
       this.user_email = null;
       this.user_error = {};
       this.WPUserController = new WordPressController();

    }
    /**
     * FUNCTIONS
     */
    //Authenticate WP User
    async authenticate(){

        let response= await this.WPUserController.WPLogIn();
 
        if(response === undefined || response === null){
            this.token = null;
            this.user_display_name = null;
            this.user_email = null;
            this.user_nicename = null;
            this.user_error = {
                code:'api_call_failure',
                status:500,
                message:"Erreur lors de la requête d'authentification WordPress API",
            }
        }

        //Authenticate success
        else if(response.token){
            this.token = response.token;
            this.user_display_name = response.user_display_name;
            this.user_email = response.user_email;
            this.user_nicename = response.user_nicename;
            this.user_error = {}

        }else{
            this.token = null;
            this.user_display_name = null;
            this.user_email = null;
            this.user_nicename = null;
            this.user_error = {
                code:response.code,
                status:response.data.status,
                message:response.message,
            }
        }



    }

}
const GlobalWPUser = new WPUser(); 
export default GlobalWPUser;
